import * as actionConsts from './actions';
import update from 'react/lib/update';

export const initState = {
  workplaces: {},
  isLoading: false,
  organizer: [],
  unread: [],
  draggingWorkplace: null,
  projectSuggestions: [],
  departmentName: "",
  columnsShowing: {
    from: 0,
    to: 3
  },
  departmentId: null,
  showSidebar: null,
  showOwnWorkplaces: false,
  projectSuggestionValue: { name: null, id: null },
  matches: [],
  updatedAt: undefined
}


export default (state = initState, action) => {
  switch (action.type) {
    case actionConsts.KANBAN_SET_INIT_STATE:
      return update(state, {
        workplaces: {
          $set: {}
        },
        organizer: {
          $set: []
        },
        hasBeenInit: {
          $set: true
        },
        showSidebar: {
          $set: action.showSidebar
        }
      });
    case actionConsts.SET_COLUMNS_SHOWING:
      return update(state, {
        columnsShowing: {
          from: {
            $set: action.from
          },
          to: {
            $set: action.to
          }
        }
      })
    case actionConsts.GET_WORKPLACES_REQUEST:
      return update(state, {
        isLoading: {
          $set: true
        },
        organizer: {
          $set: []
        },
        unread: {
          $set: action.unread
        }
      });
    case actionConsts.GET_WORKPLACES_SUCCESS:
      return update(state, {
        isLoading: {
          $set: false
        },
        workplaces: {
          $set: action.workplaces
        },
        organizer: {
          $set: action.organizer
        },
        unread: {
          $set: action.unread
        },
        departmentName: {
          $set: action.departmentName
        },
        departmentId: {
          $set: action.departmentId
        },
        matches: {
          $set: []
        },
        updatedAt: {
          $set: Date.now()
        }
      });
    case actionConsts.ADD_EMPLOYEE_TO_WORKPLACE:
      return update(state, {
        workplaces: {
          [action.workplaceId]: {
            employees: {
              [action.employee.id]: {
                $set: action.employee
              }
            }
          }
        }
      });
    case actionConsts.UPDATE_INVOICED_WORKPLACE:
      return update(state, {
        workplaces: {
          [action.workplaceId]: {
            invoiced: {
              $set: action.invoiced
            }
          }
        }
      });
    case actionConsts.ADD_MISSING_WORKPLACES:
      return update(state, {
        workplaces: {
          $merge: action.workplaces
        }
      });
    case actionConsts.UPDATE_WORKPLACE_ORGANIZER:
      return update(state, {
        organizer: {
          $set: action.organizer
        }
      });
    case actionConsts.SET_WORKPLACE_IS_DRAGGING:
      return update(state, {
        draggingWorkplace: {
          $set: action.workplaceId
        }
      });
    case actionConsts.GET_PROJECT_SUGGESTIONS_SUCCESS:
      return update(state, {
        projectSuggestions: {
          $set: action.suggestions
        }
      });
    case actionConsts.ADD_UNREAD_CHATMESSAGE:
      return update(state, {
        unread: {
          $push: [action.workplaceId]
        }
      });
    case actionConsts.SET_SHOW_OWN_WORKPLACES:
      return update(state, {
        showOwnWorkplaces: {
          $set: action.showOwnWorkplaces
        },
        projectSuggestionValue: {
          $set: { id: null, name: null }
        }
      });
    case actionConsts.SET_PROJECT_SUGGESTION_VALUE:
      return update(state, {
        projectSuggestionValue: {
          $set: action.projectSuggestionValue
        }
      });
    case actionConsts.UPDATE_WORKPLACE_COLOR:
      return update(state, {
        workplaces: {
          [action.workplaceId]: {
            color: {
              $set: action.color
            }
          }
        }
      })
    case actionConsts.REMOVE_EMPLOYEE_FROM_WORKPLACE:
      return update(state, {
        workplaces: {
          [action.workplaceId]: {
            employees: {
              $set: action.employees
            }
          }
        }
      })
    case actionConsts.SEARCH_WORKPLACES_MATCHES:
      return update(state, {
        matches: {
          $set: action.matches
        }
      })
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Kanban/reducer.js